/*
LogoutAllDevices
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { connectModal as reduxModal, hide as hideModal } from 'redux-modal';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, bindActionCreators } from 'redux';
import { addMessage } from 'store/features/common/flash/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import { resultHasErrors, errorsToSingleMessage } from 'utils/graphql-errors';
import Button from 'ui/common/button';
import messages from './messages';
import * as actionTypes from 'store/graphql/LogoutAllDevices/action-types';
import { selectIsUpdating, selectError } from 'store/graphql/LogoutAllDevices/selectors';
import LogoutAllDevicesReducer from 'store/graphql/LogoutAllDevices/reducer';
import injectReducer from 'utils/injectReducer';
import { logout } from 'store/features/auth/actions';

export const MODAL_NAME = 'logout-all-devices';

class LogoutAllDevices extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  logout() {
    this.props.logout.request();
  }

  async onSubmit() {
    const {
      client,
      updateLogoutStatusStart,
      updateLogoutStatusSuccess,
      updateLogoutStatusError,
    } = this.props;

    updateLogoutStatusStart();
    this.logout(); // Temporary fix, works sometimes. Need to force logout from BE.

    const resultFromGraphql = await client.mutate({
      mutation: gql`
        mutation {
          security_logoutAllDevices
        }
      `,
    });

    const { errors } = resultFromGraphql;

    if (!resultHasErrors({ errors })) {
      updateLogoutStatusSuccess();

      this.props.hideModal(MODAL_NAME);
    } else {
      updateLogoutStatusError(errorsToSingleMessage({ errors }));
    }
  }

  render() {
    const { show, intl: { formatMessage }, handleHide, updating } = this.props;

    return (
      <Modal size="lg" isOpen={show}>
        <ModalHeader toggle={handleHide}>
          <h1 className="lead">{formatMessage(messages.title)}</h1>
        </ModalHeader>
        <ModalBody>Are you sure you want to logout from all devices?</ModalBody>
        <ModalFooter>
          <Button isReady={false} loading={updating} className="mr-3" onClick={this.onSubmit}>
            {formatMessage(messages.logout)}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    updating: selectIsUpdating(state),
    errorMessage: selectError(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hideModal: bindActionCreators(hideModal, dispatch),
    updateLogoutStatusStart: () => dispatch({ type: actionTypes.UPDATE_LOGOUT_STATUS.START }),
    updateLogoutStatusSuccess: () => dispatch({ type: actionTypes.UPDATE_LOGOUT_STATUS.SUCCESS }),
    updateLogoutStatusError: error =>
      dispatch({ type: actionTypes.UPDATE_LOGOUT_STATUS.FAILURE, payload: { error } }),
    addMessage: bindActionCreators(addMessage, dispatch),
    logout: {
      request: bindActionCreators(logout.request, dispatch),
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'LogoutAllDevices',
  reducer: LogoutAllDevicesReducer,
});

export default compose(withReducer, withConnect)(
  reduxModal({
    name: MODAL_NAME,
  })(injectIntl(withApollo(LogoutAllDevices)))
);
